<!-- ? V2 1XP -->
<script lang="ts">
import { useTemplateRef } from 'vue';
import Icon from '../Icon/Icon.vue';

type Props = {
  endIcon?: string;
  isCancelable?: boolean;
  label: string;
  closeLabel: string;
  maxLength?: number;
  placeholder?: HTMLInputElement['placeholder'];
  startIcon?: string;
  value?: string;
  isRounded?: boolean;
};
</script>

<script setup lang="ts">
defineProps<Props>();

const emit = defineEmits([
  'focus',
  'blur',
  'keyDown',
  'keyUp',
  'keyEnter',
  'keyEsc',
  'input',
  'clear',
]);

const inputRef = useTemplateRef('input');

defineExpose({
  inputRef,
});

const handleCancel = () => {
  emit('input', {
    currentTarget: {
      value: undefined,
    },
  });
  emit('clear', true);
};
</script>

<template>
  <div :class="[$style.container, isRounded && $style.rounded]">
    <Icon v-if="startIcon" :class="$style.icon" :name="startIcon" />

    <input
      ref="input"
      :aria-label="label"
      :class="$style.input"
      :maxlength="maxLength"
      :name="label"
      :placeholder="placeholder"
      type="text"
      :value="value"
      @blur="emit('blur', $event)"
      @focus="emit('focus', $event)"
      @input="emit('input', $event)"
      @keyup.down="emit('keyDown', $event)"
      @keyup.enter="emit('keyEnter', $event)"
      @keyup.esc="emit('keyEsc', $event)"
      @keyup.up="emit('keyUp', $event)"
    />

    <Icon
      v-if="isCancelable"
      :aria-label="closeLabel"
      :class="{
        [$style.cancel]: true,
        [$style.cancelHidden]: !value || value.length === 0,
      }"
      name="close"
      @click="handleCancel"
    />
  </div>
</template>

<style lang="scss" module src="./Textfield1XP.scss" />
